import { MessageCircle } from 'lucide-react';
import { Button } from '@menlo/ui';

import { buildSupportWhatsappUrl, shouldHideWhatsappButton } from '@/constants';
import { useUserInfo } from '@/hooks/use-user-info';
import { useAuthStore } from '@/store/auth-store';

// Botão flutuante de suporte: abre o WhatsApp compartilhado do atendimento em nova aba
// com o texto pré-preenchido (loja do franqueado logado). Sem login, abre com o texto base (sem loja).
// ph-no-capture impede o autocapture do PostHog de gravar o href com o ?text= no evento de clique.
export function WhatsappButton() {
  const user = useAuthStore((state) => state.user);
  const { data: userInfo, isLoading } = useUserInfo();

  if (shouldHideWhatsappButton(!!user, isLoading)) {
    return null;
  }

  const href = buildSupportWhatsappUrl(userInfo?.storeRoles);

  return (
    <Button
      asChild
      size="icon"
      className="ph-no-capture fixed right-5 bottom-5 z-50 size-12 rounded-full bg-[#128C7E] text-white shadow-lg transition-transform hover:scale-105 hover:bg-[#128C7E]/90"
    >
      <a href={href} target="_blank" rel="noopener noreferrer" aria-label="Falar com o suporte pelo WhatsApp">
        <MessageCircle className="size-6" aria-hidden="true" />
      </a>
    </Button>
  );
}
